import { render, staticRenderFns } from "./quest-main.vue?vue&type=template&id=6f629e8b"
import script from "./quest-main.vue?vue&type=script&lang=js"
export * from "./quest-main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports